import UIPopover from 'UIComponents/tooltip/UIPopover';
import styled from 'styled-components';
import { MINI_COMMENTER_ID } from '../../../constants/sidebar';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledUIPopover = styled(UIPopover).withConfig({
  displayName: "StyledPopover__StyledUIPopover",
  componentId: "bvi7sd-0"
})(["&&&{border-radius:23px;overflow:hidden;}"]);
export default function StyledPopover(props) {
  return /*#__PURE__*/_jsx(StyledUIPopover, Object.assign({
    arrowSize: 'none',
    pinToConstraint: true,
    autoPlacement: true,
    width: 380,
    id: MINI_COMMENTER_ID,
    "data-test-id": "mini-commenter-popover",
    "data-onboarding": "mini-commenter-popover"
  }, props));
}